import { Schema } from "@comparaonline/products-schema";
import React from "react";
import { Query, QueryProps } from "react-apollo";
import { getProduct } from "../getProduct";

export type QueryResponse = Pick<Schema.Query, "productDetailsBySlug">;
export type QueryArguments = Pick<
  Schema.ProductDetailsBySlugQueryArgs,
  "productSlug" | "divisionSlug"
>;

class BaseQuery extends Query<QueryResponse, QueryArguments> {}

export interface ProductQueryProps
  extends Pick<QueryProps<QueryResponse, QueryArguments>, "children"> {
  variables: QueryArguments;
}

export const ProductQuery: React.FC<ProductQueryProps> = ({ children, variables }) => (
  <BaseQuery query={getProduct} variables={variables}>
    {data => children(data)}
  </BaseQuery>
);
